"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedReceivableInvoice = void 0;
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, loanProductSlug, creditFacilitySlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Receivable Invoice`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            loanProductSlug,
            creditFacilitySlug,
            description: 'this represents an extracted data from invoice (pdf)',
            assetVerificationConfig: {
                fields: [
                    {
                        comparisonFormula: 'dynamicIntermediateFields.amount = documentation.amount',
                        receivableDocumentionField: 'amount',
                        receivableResponseTapeField: 'dynamicIntermediateFields.amount',
                    },
                    {
                        comparisonFormula: 'baseFields.company_name = documentation.company_name',
                        receivableDocumentionField: 'company_name',
                        receivableResponseTapeField: 'baseFields.company_name',
                    },
                ],
            },
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = (0, utils_1.copyNodeConfiguration)({
            nodeToCopy,
            isNode,
            nodeType: types_1.nodeType,
            suggestedSerialNumber,
        });
    }
    return nodeData;
};
const getTapeDefinition = ({ tapeBuilder, artifactId, }) => {
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `tapeDefinitionResult is not valid for ${artifactId}`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `No definition found for ${artifactId}`);
    return tapeDefinitionResult.data;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, graph, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_intermediateTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 0,
        maxOutputs: 0,
    });
    const allDocNodesForLpCf = graph.nodes
        .filter(isNode)
        .filter(({ configuration }) => configuration.creditFacilitySlug ===
        node.configuration.creditFacilitySlug &&
        configuration.loanProductSlug === node.configuration.loanProductSlug);
    if ((0, utils_1.getLowestNodeIdIfMultiple)(allDocNodesForLpCf) ===
        node.metadata.tapeBuilderNodeId) {
        errors.push(`There should be only one Receivable Invoice for [cf:${node.configuration.creditFacilitySlug}, lp:${node.configuration.loanProductSlug}]. Found [${allDocNodesForLpCf.length}].`);
    }
    return errors;
};
const getGeneratedLoanTapeNode = ({ graph, creditFacilitySlug, loanProductSlug, }) => {
    const generatedLoanTapeNodes = graph.dataTapes.filter((dataTape) => dataTape.type === 'generatedLoanTape' &&
        dataTape.loanProductSlug === loanProductSlug);
    // there could be multiple generatedLoanTape nodes for the same loanProductSlug
    // but different creditFacilitySlug. if we find multiple filter by creditFacilitySlug
    // Note: we did not filter for creditFacilitySlug in the query above
    // because when a LP goes into single CF (preassignedLoanTape) it specifies its CF as null.
    if (generatedLoanTapeNodes.length > 1) {
        const filteredNodes = generatedLoanTapeNodes.filter((node) => node.creditFacilitySlug === creditFacilitySlug);
        (0, common_1.finleyAssert)(filteredNodes.length === 1, `found multiple generatedLoanTape nodes for loanProductSlug: ${loanProductSlug} and creditFacilitySlug: ${creditFacilitySlug}`);
        return filteredNodes[0];
    }
    return generatedLoanTapeNodes[0];
};
const getAvailableDocumentationFields = ({ inputTapeDefinition, }) => {
    const errors = [];
    const { baseFields } = inputTapeDefinition;
    // There are two variations for asset verification graphs
    // 1) json (when using asset2json)
    // 2) legacy csv (when using pdf2csv)
    // json path.
    if (inputTapeDefinition.isJson) {
        // just gather the available fields in JSON tape.
        const availableDocumentationFields = baseFields.map(({ field }) => field);
        return {
            availableDocumentationFields,
            errors,
        };
    }
    // @asset2json: remove legacy path after graphs are migrated.
    // on legacy path we need more validations to ensure that
    // other metadata fields are formatted correctly.
    // input tape must is a csv with following format
    // fieldName#value
    // fieldName#confidence
    // fieldName#pageNumber
    // fieldName#error
    // fieldName#raw (optional - only available where fieldName#value is sanitized)
    // 1st filter for for fieldName#value
    const availableDocumentationFields = baseFields
        .filter((field) => field.field.includes('#value'))
        .map((field) => field.field.split('#')[0]);
    availableDocumentationFields.forEach((fieldName) => {
        const valueField = baseFields.find((f) => f.field === `${fieldName}#value`);
        // this is an assert (and not config error) because we got availableDocumentationFields from value fields.
        (0, common_1.finleyAssert)(valueField, `field [${fieldName}#value] is missing`);
        const rawField = baseFields.find((f) => f.field === `${fieldName}#raw`);
        if (!rawField) {
            // we allow missing raw field only if value field is of type string
            if (!['string', 'optionalString'].includes(valueField.type)) {
                errors.push(`[${fieldName}#raw] must be present in the receivableInvoice tape when value field is not of type string. [Found:${valueField.type}]`);
            }
        }
        else if (!['string', 'optionalString'].includes(rawField.type)) {
            // raw field is optional only if value field is of type string
            errors.push(`[${fieldName}#raw] must be of type string or optionalString. [Found:${valueField.type}]`);
        }
        const confidenceField = baseFields.find((f) => f.field === `${fieldName}#confidence`);
        if (!confidenceField) {
            errors.push(`[${fieldName}#confidence] must be present in the receivableInvoice tape`);
        }
        else if (confidenceField.type !== 'optionalFloat') {
            errors.push(`[${fieldName}#confidence] must be of type optionalFloat. [Found:${confidenceField.type}]`);
        }
        const errorField = baseFields.find((f) => f.field === `${fieldName}#error`);
        if (!errorField) {
            errors.push(`[${fieldName}#error] must be present in the receivableInvoice tape`);
        }
        else if (errorField.type !== 'optionalString') {
            errors.push(`[${fieldName}#error] must be of type optionalString. [Found:${errorField.type}]`);
        }
        const pageNumberField = baseFields.find((f) => f.field === `${fieldName}#pageNumber`);
        if (!pageNumberField) {
            errors.push(`[${fieldName}#pageNumber] must be present in the receivableInvoice tape`);
        }
        else if (!['optionalInteger', 'integer'].includes(pageNumberField.type)) {
            errors.push(`[${fieldName}#pageNumber] must be of type integer or optionalInteger. [Found:${pageNumberField.type}]`);
        }
    });
    return {
        availableDocumentationFields,
        errors,
    };
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    // funding request
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'receivableInvoice', 'node is not a fundingRequest');
    const { assetVerificationConfig, sampling } = tape.configuration;
    const { fields: assetVerificationFields } = assetVerificationConfig;
    const docFieldReferenced = assetVerificationFields.map((field) => field.receivableDocumentionField);
    // we want to ensure that
    // 1) documentation has all the fields referenced here.
    // 2) loan tape has all the fields referenced here.
    // 3) the comparison formula is valid.
    // 4) the sampling config is valid
    // part 1) ensure that documentation has all the fields referenced here.
    // for this we look at input tape to this node.
    const inputs = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    (0, common_1.finleyAssert)(inputs.length === 1, 'expected 1 input to receivableInvoice');
    const inputTapeDefinition = getTapeDefinition({
        tapeBuilder,
        artifactId: inputs[0],
    });
    // get available fields from input tape.
    const { availableDocumentationFields, errors, } = getAvailableDocumentationFields({
        inputTapeDefinition,
    });
    // return any errors found in the input tape.
    if (errors.length > 0) {
        return errors;
    }
    const missingDocumentationFields = docFieldReferenced.filter((field) => !availableDocumentationFields.includes(field));
    if (missingDocumentationFields.length > 0) {
        return [
            `[${missingDocumentationFields.join(', ')}] fields are listed in assetVerificationConfig but are missing from documentation tape`,
        ];
    }
    // part 2) ensure that loan tape has all the fields referenced here.
    // we want to find loanTape for the given loanProductSlug/creditFacilitySlug
    // and ensure that the fields in assetVerificationConfig are subset of
    // the fields in the generated loan tape for the given loanProductId
    const generatedLoanTapeNode = getGeneratedLoanTapeNode({
        graph,
        creditFacilitySlug: tape.creditFacilitySlug,
        loanProductSlug: tape.loanProductSlug,
    });
    const generatedLoanTapeDefinition = getTapeDefinition({
        tapeBuilder,
        artifactId: generatedLoanTapeNode.id,
    });
    const generatedLoanTapeFields = generatedLoanTapeDefinition.baseFields.map(({ field }) => field);
    // find the list of fields in asset verification config which are prefixed with  "baseFields."
    const assetVerificationBaseFields = assetVerificationFields
        .filter((field) => field.receivableResponseTapeField.startsWith('baseFields.'))
        .map((field) => field.receivableResponseTapeField.split('.')[1]);
    const missingLoanTapeFields = assetVerificationBaseFields.filter((field) => !generatedLoanTapeFields.includes(field));
    if (missingLoanTapeFields.length > 0) {
        return missingLoanTapeFields.map((field) => `field ${field} is listed in assetVerificationConfig but is missing from baseFields definition`);
    }
    // part 3) validate the comparison formula
    // unfortunately we cannot validate any intermediateCalc references
    // but we should validate the rest.
    const formulaErrors = (0, calc_agent_1.checkAssetDocumentationFormulaErrors)({
        formulas: assetVerificationFields.map((field) => field.comparisonFormula),
        dynamicIntermediateFields: [],
        baseFields: generatedLoanTapeFields,
        documentationFields: availableDocumentationFields,
        ignoreDynamicIntermediateFields: true,
    });
    const allFormulaErrors = formulaErrors.map((error) => error.errorMessages.join('\n'));
    // part 4) validate sampling config
    if (sampling) {
        switch (sampling.type) {
            case 'criteria': {
                const samplingErrors = (0, calc_agent_1.checkAssetDocumentationFormulaErrors)({
                    formulas: sampling.config.criterion.map((criteria) => criteria.formula),
                    dynamicIntermediateFields: [],
                    baseFields: generatedLoanTapeFields,
                    documentationFields: [],
                    ignoreDynamicIntermediateFields: true,
                });
                samplingErrors.forEach((samplingError) => {
                    allFormulaErrors.push(samplingError.errorMessages.join('\n'));
                });
                sampling.config.criterion.forEach((criteria) => {
                    if (criteria.maximum && criteria.maximum < 0) {
                        allFormulaErrors.push(`Sampling [criteria:${criteria.name}] maximum must be >= 0.`);
                    }
                    if (criteria.percentageRate &&
                        (criteria.percentageRate < 0 || criteria.percentageRate > 1)) {
                        allFormulaErrors.push(`Sampling [criteria:${criteria.name}] percentageRate must between 0 and 1, inclusive.`);
                    }
                });
                break;
            }
            case 'sampleAll':
            default:
                break;
        }
    }
    return allFormulaErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_generatedReceivableInvoice = {
    nodeTypeText: 'Documentation',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    badgeTexts: ['Documentation'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map